import React from 'react'
import restaurantphoto from "../images/restaurant photo.jpg";
import Multicuisionrestro from "../images/Restaurant img.jpg";
import frontview from "../images/restaurant front view.jpg";

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


function Multicuisine() {
  return (
    <div>
           <div className='album py-0'>
                <div className='container'>
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                                <Zoom>
                                <img src={restaurantphoto} className="card-img-top imge2" alt="restaurantphoto"/>
                                </Zoom>
                                <div className="overlay1"> MULTICUISINE AREA </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                          <Zoom>
                                <img src={Multicuisionrestro} className="card-img-top image2" alt="Multicuisionrestro"/>
                                </Zoom>
                               
                                <div className="overlay1">MULTICUISINE RESTAURANT </div>
                            </div>
                        </div>
                   
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={frontview} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">MULTICUISINE FRONT VIEW </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Multicuisine